import { create } from 'zustand';

interface TaskStore {
    taskCount: number;
    incrementTask: () => void;
    decrementTask: () => void;
    setTaskCount: (count: number) => void;
}

export const useTaskStore = create<TaskStore>((set) => ({
    taskCount: 0,
    incrementTask: () => 
        set((state) => ({
            taskCount: state.taskCount + 1
        })),
    decrementTask: () => 
        set((state) => ({
            taskCount: state.taskCount - 1
        })),
    setTaskCount: (count: number) => 
        set(() => ({
            taskCount: count
        })),
}));
